import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const MethylationDetoxificationOverviewDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const cyp1a1 = getGenePalette(geneColors.CYP1A1);
  const cyp1a2 = getGenePalette(geneColors.CYP1A2);
  const cyp1b1 = getGenePalette(geneColors.CYP1B1);
  const cyp2a6 = getGenePalette(geneColors.CYP2A6);
  const cyp2c9 = getGenePalette(geneColors.CYP2C9);
  const cyp2d6 = getGenePalette(geneColors.CYP2D6);
  const cyp3a4 = getGenePalette(geneColors.CYP3A4);
  const cyp2r1 = getGenePalette(geneColors.CYP2R1);
  const cyp4f2 = getGenePalette(geneColors.CYP4F2);
  const cyp2e1 = getGenePalette(geneColors.CYP2E1);
  const gpx1 = getGenePalette(geneColors.GPX1);
  const sod2 = getGenePalette(geneColors.SOD2);
  const nqo1 = getGenePalette(geneColors.NQO1);
  const ugt1a1 = getGenePalette(geneColors.UGT1A1);
  const ugt1a6 = getGenePalette(geneColors.UGT1A6);
  const ugt2b15 = getGenePalette(geneColors.UGT2B15);
  const sult1a1 = getGenePalette(geneColors.SULT1A1);
  const nat1 = getGenePalette(geneColors.NAT1);
  const nat2 = getGenePalette(geneColors.NAT2);
  const gstm1 = getGenePalette(geneColors.GSTM1);
  const gstp1 = getGenePalette(geneColors.GSTP1);
  const gstt1 = getGenePalette(geneColors.GSTT1);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18291_211478)">
        <rect width={1024} height={1344} transform="translate(0 176)" fill="white" />
        <g id="detoxification-diagram">
          <rect width={1024} height={1344} transform="translate(0 176)" fill="white" />
          <g id="background">
            <rect width={544} height={745} transform="translate(222 239)" fill="#FFF1F2" />
            <g id="Report titles">
              <text
                id="25-Hydroxy Vitamin D"
                fill="#282828"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={238.961} y={276.16}>
                  Liver
                </tspan>
              </text>
            </g>
            <g id="gene-CYP1A1" {...geneGroupProps("CYP1A1", onGeneClick)}>
              <g id="gene-lozenge_5">
                <path
                  d="M259 393.5C259 391.291 260.791 389.5 263 389.5H355C357.209 389.5 359 391.291 359 393.5V421.5C359 423.709 357.209 425.5 355 425.5H263C260.791 425.5 259 423.709 259 421.5V393.5Z"
                  fill={cyp1a1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={283.266} y={412.948}>
                    CYP1A1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp1a1"
                groupId="gene-snps"
                genePalette={cyp1a1}
                startX={267}
                startY={427.5}
                snpCount={getGeneSnpCount("CYP1A1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP1A2" {...geneGroupProps("CYP1A2", onGeneClick)}>
              <g id="gene-lozenge_6">
                <path
                  d="M259 445.5C259 443.291 260.791 441.5 263 441.5H355C357.209 441.5 359 443.291 359 445.5V473.5C359 475.709 357.209 477.5 355 477.5H263C260.791 477.5 259 475.709 259 473.5V445.5Z"
                  fill={cyp1a2.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_2"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={281.461} y={464.948}>
                    CYP1A2
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp1a2"
                groupId="gene-snps_2"
                genePalette={cyp1a2}
                startX={267}
                startY={479.5}
                snpCount={getGeneSnpCount("CYP1A2", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP1B1" {...geneGroupProps("CYP1B1", onGeneClick)}>
              <g id="gene-lozenge_7">
                <path
                  d="M259 497.5C259 495.291 260.791 493.5 263 493.5H355C357.209 493.5 359 495.291 359 497.5V525.5C359 527.709 357.209 529.5 355 529.5H263C260.791 529.5 259 527.709 259 525.5V497.5Z"
                  fill={cyp1b1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_3"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={283.328} y={516.948}>
                    CYP1B1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp1b1"
                groupId="gene-snps_3"
                genePalette={cyp1b1}
                startX={267}
                startY={531.5}
                snpCount={getGeneSnpCount("CYP1B1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP2A6" {...geneGroupProps("CYP2A6", onGeneClick)}>
              <g id="gene-lozenge_8">
                <path
                  d="M259 549.5C259 547.291 260.791 545.5 263 545.5H355C357.209 545.5 359 547.291 359 549.5V577.5C359 579.709 357.209 581.5 355 581.5H263C260.791 581.5 259 579.709 259 577.5V549.5Z"
                  fill={cyp2a6.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_4"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={280.086} y={568.948}>
                    CYP2A6
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp2a6"
                groupId="gene-snps_4"
                genePalette={cyp2a6}
                startX={267}
                startY={583.5}
                snpCount={getGeneSnpCount("CYP2A6", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP2C9" {...geneGroupProps("CYP2C9", onGeneClick)}>
              <g id="gene-lozenge_9">
                <path
                  d="M259 601.5C259 599.291 260.791 597.5 263 597.5H355C357.209 597.5 359 599.291 359 601.5V629.5C359 631.709 357.209 633.5 355 633.5H263C260.791 633.5 259 631.709 259 629.5V601.5Z"
                  fill={cyp2c9.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_5"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={279.492} y={620.948}>
                    CYP2C9
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp2c9"
                groupId="gene-snps_5"
                genePalette={cyp2c9}
                startX={267}
                startY={635.5}
                snpCount={getGeneSnpCount("CYP2C9", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP2D6" {...geneGroupProps("CYP2D6", onGeneClick)}>
              <g id="gene-lozenge_10">
                <path
                  d="M259 656.5C259 654.291 260.791 652.5 263 652.5H355C357.209 652.5 359 654.291 359 656.5V684.5C359 686.709 357.209 688.5 355 688.5H263C260.791 688.5 259 686.709 259 684.5V656.5Z"
                  fill={cyp2d6.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_6"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={279.484} y={675.948}>
                    CYP2D6
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp2d6"
                groupId="gene-snps_6"
                genePalette={cyp2d6}
                startX={267}
                startY={690.5}
                snpCount={getGeneSnpCount("CYP2D6", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP3A4" {...geneGroupProps("CYP3A4", onGeneClick)}>
              <g id="gene-lozenge_11">
                <path
                  d="M259 708.5C259 706.291 260.791 704.5 263 704.5H355C357.209 704.5 359 706.291 359 708.5V736.5C359 738.709 357.209 740.5 355 740.5H263C260.791 740.5 259 738.709 259 736.5V708.5Z"
                  fill={cyp3a4.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_7"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={279.969} y={727.948}>
                    CYP3A4
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp3a4"
                groupId="gene-snps_7"
                genePalette={cyp3a4}
                startX={267}
                startY={742.5}
                snpCount={getGeneSnpCount("CYP3A4", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP2R1" {...geneGroupProps("CYP2R1", onGeneClick)}>
              <g id="gene-lozenge_12">
                <path
                  d="M259 760.5C259 758.291 260.791 756.5 263 756.5H355C357.209 756.5 359 758.291 359 760.5V788.5C359 790.709 357.209 792.5 355 792.5H263C260.791 792.5 259 790.709 259 788.5V760.5Z"
                  fill={cyp2r1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_8"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={281.867} y={779.948}>
                    CYP2R1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp2r1"
                groupId="gene-snps_8"
                genePalette={cyp2r1}
                startX={267}
                startY={794.5}
                snpCount={getGeneSnpCount("CYP2R1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP4F2" {...geneGroupProps("CYP4F2", onGeneClick)}>
              <g id="gene-lozenge_13">
                <path
                  d="M259 812.5C259 810.291 260.791 808.5 263 808.5H355C357.209 808.5 359 810.291 359 812.5V840.5C359 842.709 357.209 844.5 355 844.5H263C260.791 844.5 259 842.709 259 840.5V812.5Z"
                  fill={cyp4f2.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_9"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={280.969} y={831.948}>
                    CYP4F2
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp4f2"
                groupId="gene-snps_9"
                genePalette={cyp4f2}
                startX={267}
                startY={846.5}
                snpCount={getGeneSnpCount("CYP4F2", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-CYP2E1" {...geneGroupProps("CYP2E1", onGeneClick)}>
              <g id="gene-lozenge_14">
                <path
                  d="M259 864.5C259 862.291 260.791 860.5 263 860.5H355C357.209 860.5 359 862.291 359 864.5V892.5C359 894.709 357.209 896.5 355 896.5H263C260.791 896.5 259 894.709 259 892.5V864.5Z"
                  fill={cyp2e1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_10"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={282.414} y={883.948}>
                    CYP2E1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="cyp2e1"
                groupId="gene-snps_10"
                genePalette={cyp2e1}
                startX={267}
                startY={898.5}
                snpCount={getGeneSnpCount("CYP2E1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-GPX1" {...geneGroupProps("GPX1", onGeneClick)}>
              <g id="gene-lozenge_15">
                <path
                  d="M394 393.5C394 391.291 395.791 389.5 398 389.5H490C492.209 389.5 494 391.291 494 393.5V421.5C494 423.709 492.209 425.5 490 425.5H398C395.791 425.5 394 423.709 394 421.5V393.5Z"
                  fill={gpx1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_11"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={425.656} y={412.948}>
                    GPX1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="gpx1"
                groupId="gene-snps_11"
                genePalette={gpx1}
                startX={402}
                startY={427.5}
                snpCount={getGeneSnpCount("GPX1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-UGT1A1" {...geneGroupProps("UGT1A1", onGeneClick)}>
              <g id="gene-lozenge_16">
                <path
                  d="M637 393.5C637 391.291 638.791 389.5 641 389.5H733C735.209 389.5 737 391.291 737 393.5V421.5C737 423.709 735.209 425.5 733 425.5H641C638.791 425.5 637 423.709 637 421.5V393.5Z"
                  fill={ugt1a1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_12"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={661} y={412.948}>
                    UGT1A1
                  </tspan>
                </text>
                <path
                  id="*_3"
                  d="M747.748 385.906V388.324L743.818 388.195L746.064 391.434L743.861 392.73L741.874 389.231L739.887 392.73L737.684 391.434L739.93 388.195L736 388.324L736 385.906L739.93 386.035L737.684 382.796L739.887 381.5L741.874 384.999L743.861 381.5L746.064 382.796L743.818 386.035L747.748 385.906Z"
                  fill="black"
                />
              </g>
              <GeneSnpShapes
                id="ugt1a1"
                groupId="gene-snps_12"
                genePalette={ugt1a1}
                startX={645}
                startY={427.5}
                snpCount={getGeneSnpCount("UGT1A1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-UGT1A6" {...geneGroupProps("UGT1A6", onGeneClick)}>
              <g id="gene-lozenge_17">
                <path
                  d="M637 445.5C637 443.291 638.791 441.5 641 441.5H733C735.209 441.5 737 443.291 737 445.5V473.5C737 475.709 735.209 477.5 733 477.5H641C638.791 477.5 637 475.709 637 473.5V445.5Z"
                  fill={ugt1a6.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_13"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={659.109} y={464.948}>
                    UGT1A6
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="ugt1a6"
                groupId="gene-snps_13"
                genePalette={ugt1a6}
                startX={645}
                startY={479.5}
                snpCount={getGeneSnpCount("UGT1A6", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-UGT2B15" {...geneGroupProps("UGT2B15", onGeneClick)}>
              <g id="gene-lozenge_18">
                <path
                  d="M637 497.5C637 495.291 638.791 493.5 641 493.5H733C735.209 493.5 737 495.291 737 497.5V525.5C737 527.709 735.209 529.5 733 529.5H641C638.791 529.5 637 527.709 637 525.5V497.5Z"
                  fill={ugt2b15.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_14"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={655.578} y={516.948}>
                    UGT2B15
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="ugt2b15"
                groupId="gene-snps_14"
                genePalette={ugt2b15}
                startX={645}
                startY={531.5}
                snpCount={getGeneSnpCount("UGT2B15", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-SULT1A1" {...geneGroupProps("SULT1A1", onGeneClick)}>
              <g id="gene-lozenge_19">
                <path
                  d="M637 577.5C637 575.291 638.791 573.5 641 573.5H733C735.209 573.5 737 575.291 737 577.5V605.5C737 607.709 735.209 609.5 733 609.5H641C638.791 609.5 637 607.709 637 605.5V577.5Z"
                  fill={sult1a1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_15"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={659.023} y={596.948}>
                    SULT1A1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="sult1a1"
                groupId="gene-snps_15"
                genePalette={sult1a1}
                startX={645}
                startY={611.5}
                snpCount={getGeneSnpCount("SULT1A1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-NAT1" {...geneGroupProps("NAT1", onGeneClick)}>
              <g id="gene-lozenge_20">
                <path
                  d="M637 668.5C637 666.291 638.791 664.5 641 664.5H733C735.209 664.5 737 666.291 737 668.5V696.5C737 698.709 735.209 700.5 733 700.5H641C638.791 700.5 637 698.709 637 696.5V668.5Z"
                  fill={nat1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_16"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={669.648} y={687.948}>
                    NAT1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="nat1"
                groupId="gene-snps_16"
                genePalette={nat1}
                startX={645}
                startY={702.5}
                snpCount={getGeneSnpCount("NAT1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-NAT2" {...geneGroupProps("NAT2", onGeneClick)}>
              <g id="gene-lozenge_21">
                <path
                  d="M637 726.5C637 724.291 638.791 722.5 641 722.5H733C735.209 722.5 737 724.291 737 726.5V754.5C737 756.709 735.209 758.5 733 758.5H641C638.791 758.5 637 756.709 637 754.5V726.5Z"
                  fill={nat2.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_17"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={668.508} y={745.948}>
                    NAT2
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="nat2"
                groupId="gene-snps_17"
                genePalette={nat2}
                startX={645}
                startY={760.5}
                snpCount={getGeneSnpCount("NAT2", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-GSTM1" {...geneGroupProps("GSTM1", onGeneClick)}>
              <g id="gene-lozenge_22">
                <path
                  d="M637 812.5C637 810.291 638.791 808.5 641 808.5H733C735.209 808.5 737 810.291 737 812.5V840.5C737 842.709 735.209 844.5 733 844.5H641C638.791 844.5 637 842.709 637 840.5V812.5Z"
                  fill={gstm1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_18"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={662.867} y={831.948}>
                    GSTM1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="gstm1"
                groupId="gene-snps_18"
                genePalette={gstm1}
                startX={645}
                startY={846.5}
                snpCount={getGeneSnpCount("GSTM1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-GSTP1" {...geneGroupProps("GSTP1", onGeneClick)}>
              <g id="gene-lozenge_23">
                <path
                  d="M637 864.5C637 862.291 638.791 860.5 641 860.5H733C735.209 860.5 737 862.291 737 864.5V892.5C737 894.709 735.209 896.5 733 896.5H641C638.791 896.5 637 894.709 637 892.5V864.5Z"
                  fill={gstp1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_19"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={664.586} y={883.948}>
                    GSTP1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="gstp1"
                groupId="gene-snps_19"
                genePalette={gstp1}
                startX={645}
                startY={898.5}
                snpCount={getGeneSnpCount("GSTP1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-GSTT1" {...geneGroupProps("GSTT1", onGeneClick)}>
              <g id="gene-lozenge_24">
                <path
                  d="M637 916.5C637 914.291 638.791 912.5 641 912.5H733C735.209 912.5 737 914.291 737 916.5V944.5C737 946.709 735.209 948.5 733 948.5H641C638.791 948.5 637 946.709 637 944.5V916.5Z"
                  fill={gstt1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_20"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={664.961} y={935.948}>
                    GSTT1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="gstt1"
                groupId="gene-snps_20"
                genePalette={gstt1}
                startX={645}
                startY={950.5}
                snpCount={getGeneSnpCount("GSTT1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-SOD2" {...geneGroupProps("SOD2", onGeneClick)}>
              <g id="gene-lozenge_25">
                <path
                  d="M454 448.5C454 446.291 455.791 444.5 458 444.5H550C552.209 444.5 554 446.291 554 448.5V476.5C554 478.709 552.209 480.5 550 480.5H458C455.791 480.5 454 478.709 454 476.5V448.5Z"
                  fill={sod2.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_21"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={483.211} y={467.948}>
                    SOD2
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="sod2"
                groupId="gene-snps_21"
                genePalette={sod2}
                startX={462}
                startY={482.5}
                snpCount={getGeneSnpCount("SOD2", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-NQO1" {...geneGroupProps("NQO1", onGeneClick)}>
              <g id="gene-lozenge_26">
                <path
                  d="M510 393.5C510 391.291 511.791 389.5 514 389.5H606C608.209 389.5 610 391.291 610 393.5V421.5C610 423.709 608.209 425.5 606 425.5H514C511.791 425.5 510 423.709 510 421.5V393.5Z"
                  fill={nqo1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_22"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={538.969} y={412.948}>
                    NQO1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="nqo1"
                groupId="gene-snps_22"
                genePalette={nqo1}
                startX={518}
                startY={427.5}
                snpCount={getGeneSnpCount("NQO1", expectedSnps, geneColors)}
              />
            </g>
            <g id="Report titles_2">
              <text
                id="25-Hydroxy Vitamin D_2"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={272.988} y={328.08}>
                  Detox Phase I{" "}
                </tspan>
                <tspan x={258.357} y={344.08}>
                  (Biotransformation)
                </tspan>
              </text>
            </g>
            <g id="Report titles_3">
              <text
                id="25-Hydroxy Vitamin D_3"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={472.854} y={328.08}>
                  Intermediary{" "}
                </tspan>
                <tspan x={446.322} y={344.08}>
                  Antioxidant Protection
                </tspan>
              </text>
            </g>
            <g id="Report titles_4">
              <text
                id="25-Hydroxy Vitamin D_4"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={646.105} y={332.08}>
                  Detox Phase II
                </tspan>
              </text>
            </g>
            <path
              id="Vector 423"
              d="M435 619L375.5 407H367M435 619L375.5 462H367M435 619L375.5 512.5H367M435 619L375.5 563H367M435 619H367M435 619L375.5 669H367M435 619L375.5 721H367M435 619L375.5 774.5H367M435 619L375.5 824.5H367M435 619L375.5 878.5H367"
              stroke="#282828"
              strokeWidth={1.4}
            />
            <path
              id="Vector 424"
              d="M570 618L569.326 617.811L569.282 617.969L569.312 618.131L570 618ZM629.5 406V405.3H628.969L628.826 405.811L629.5 406ZM638 406L631 401.959V410.041L638 406ZM629.5 461V460.3H629.017L628.845 460.752L629.5 461ZM638 461L631 456.959V465.041L638 461ZM629.5 511.5V510.8H629.089L628.889 511.159L629.5 511.5ZM638 511.5L631 507.459V515.541L638 511.5ZM629.5 591.5V590.8H629.351L629.215 590.861L629.5 591.5ZM638 591.5L631 587.459V595.541L638 591.5ZM628 684L627.474 684.462L627.683 684.7H628V684ZM636.5 684L629.5 679.959V688.041L636.5 684ZM629.5 740L628.871 740.307L629.063 740.7H629.5V740ZM638 740L631 735.959V744.041L638 740ZM629.5 827.5L628.827 827.691L628.971 828.2H629.5V827.5ZM641.5 827.5L634.5 823.459V831.541L641.5 827.5ZM629.5 879L628.818 879.156L628.942 879.7H629.5V879ZM641.5 879L634.5 874.959V883.041L641.5 879ZM629.5 930.5L628.812 930.631L628.921 931.2H629.5V930.5ZM641.5 930.5L634.5 926.459V934.541L641.5 930.5ZM570 618L570.674 618.189L630.174 406.189L629.5 406L628.826 405.811L569.326 617.811L570 618ZM629.5 406V406.7H631.7V406V405.3H629.5V406ZM570 618L570.655 618.248L630.155 461.248L629.5 461L628.845 460.752L569.345 617.752L570 618ZM629.5 461V461.7H631.7V461V460.3H629.5V461ZM570 618L570.611 618.341L630.111 511.841L629.5 511.5L628.889 511.159L569.389 617.659L570 618ZM629.5 511.5V512.2H631.7V511.5V510.8H629.5V511.5ZM570 618L570.285 618.639L629.785 592.139L629.5 591.5L629.215 590.861L569.715 617.361L570 618ZM629.5 591.5V592.2H631.7V591.5V590.8H629.5V591.5ZM570 618L569.474 618.462L627.474 684.462L628 684L628.526 683.538L570.526 617.538L570 618ZM628 684V684.7H630.2V684V683.3H628V684ZM570 618L569.371 618.307L628.871 740.307L629.5 740L630.129 739.693L570.629 617.693L570 618ZM629.5 740V740.7H631.7V740V739.3H629.5V740ZM570 618L569.327 618.191L628.827 827.691L629.5 827.5L630.173 827.309L570.673 617.809L570 618ZM629.5 827.5V828.2H635.2V827.5V826.8H629.5V827.5ZM570 618L569.318 618.156L628.818 879.156L629.5 879L630.182 878.844L570.682 617.844L570 618ZM629.5 879V879.7H635.2V879V878.3H629.5V879ZM570 618L569.312 618.131L628.812 930.631L629.5 930.5L630.188 930.369L570.688 617.869L570 618ZM629.5 930.5V931.2H635.2V930.5V929.8H629.5V930.5Z"
              fill="#282828"
            />
            <g id="Frame 468">
              <rect
                x={434.7}
                y={570.2}
                width={134.6}
                height={102.6}
                stroke="#282828"
                strokeWidth={1.4}
              />
              <g id="Rich Text Block">
                <text
                  id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={468.982} y={614.267}>
                    Activated{" "}
                  </tspan>
                  <tspan x={457.676} y={638.267}>
                    intermediates
                  </tspan>
                </text>
              </g>
            </g>
            <g id="lines">
              <path
                id="Vector"
                d="M441.658 442.7L441.658 442L440.258 442L440.258 442.7L440.958 442.7L441.658 442.7ZM440.958 559L445 552L436.917 552L440.958 559ZM440.958 442.7L440.258 442.7L440.258 552.7L440.958 552.7L441.658 552.7L441.658 442.7L440.958 442.7Z"
                fill="#1A1A1A"
              />
            </g>
            <g id="lines_2">
              <path
                id="Vector_2"
                d="M566.658 443.7L566.658 443L565.258 443L565.258 443.7L565.958 443.7L566.658 443.7ZM565.958 560L570 553L561.917 553L565.958 560ZM565.958 443.7L565.258 443.7L565.258 553.7L565.958 553.7L566.658 553.7L566.658 443.7L565.958 443.7Z"
                fill="#1A1A1A"
              />
            </g>
            <g id="lines_3">
              <path
                id="Vector_3"
                d="M506.658 490.7L506.658 490L505.258 490L505.258 490.7L505.958 490.7L506.658 490.7ZM505.958 560L510 553L501.917 553L505.958 560ZM505.958 490.7L505.258 490.7L505.258 553.7L505.958 553.7L506.658 553.7L506.658 490.7L505.958 490.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <path
            id="Vector 425"
            d="M482.703 984L482.796 983.306L482.699 983.293L482.602 983.307L482.703 984ZM295 1011.56L294.898 1010.86L294.3 1010.95V1011.56H295ZM295 1046L299.041 1039H290.959L295 1046ZM689 1011.56H689.7V1010.94L689.093 1010.86L689 1011.56ZM689 1046L693.041 1039H684.959L689 1046ZM482.703 984L482.602 983.307L294.898 1010.86L295 1011.56L295.102 1012.25L482.805 984.693L482.703 984ZM295 1011.56H294.3V1039.7H295H295.7V1011.56H295ZM482.703 984L482.611 984.694L688.907 1012.25L689 1011.56L689.093 1010.86L482.796 983.306L482.703 984ZM689 1011.56H688.3V1039.7H689H689.7V1011.56H689Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector 424_2"
            d="M808.5 618L749 406H740.5M808.5 618L749 461H740.5M808.5 618L749 511.5H740.5M808.5 618L749 591.5H740.5M808.5 618L750.5 684H742M808.5 618L749 740H740.5M808.5 618L749 827.5H737M808.5 618L749 879H737M808.5 618L749 930.5H737"
            stroke="#282828"
            strokeWidth={1.4}
          />
          <g id="Frame 466">
            <path
              d="M472.006 1052V1052.7H474C474.756 1052.7 475.493 1052.77 476.206 1052.92L476.341 1052.23C477.915 1052.54 479.378 1053.16 480.666 1054.02L480.278 1054.6C481.511 1055.43 482.572 1056.49 483.397 1057.72L483.978 1057.33C484.84 1058.62 485.459 1060.08 485.771 1061.66L485.085 1061.79C485.226 1062.51 485.3 1063.24 485.3 1064V1066H486V1070H485.3V1074H486V1078H485.3V1082H486V1086H485.3V1090H486V1094H485.3V1098H486V1102H485.3V1106H486V1110H485.3V1114H486V1118H485.3V1122H486V1126H485.3V1130H486V1134H485.3V1138H486V1142H485.3V1146H486V1150H485.3V1154H486V1158H485.3V1162H486V1166H485.3V1170H486V1174H485.3V1178H486V1182H485.3V1186H486V1190H485.3V1194H486V1198H485.3V1202H486V1206H485.3V1210H486V1214H485.3V1218H486V1222H485.3V1226H486V1230H485.3V1234H486V1238H485.3V1240C485.3 1240.76 485.226 1241.49 485.085 1242.21L485.771 1242.34C485.459 1243.92 484.84 1245.38 483.978 1246.67L483.397 1246.28C482.572 1247.51 481.511 1248.57 480.278 1249.4L480.666 1249.98C479.378 1250.84 477.915 1251.46 476.341 1251.77L476.206 1251.08C475.493 1251.23 474.756 1251.3 474 1251.3H472.006V1252H468.018V1251.3H464.029V1252H460.041V1251.3H456.053V1252H452.064V1251.3H448.075V1252H444.087V1251.3H440.099V1252H436.11V1251.3H432.122V1252H428.134V1251.3H424.146V1252H420.157V1251.3H416.169V1252H412.181V1251.3H408.191V1252H404.203V1251.3H400.215V1252H396.227V1251.3H392.238V1252H388.25V1251.3H384.262V1252H380.273V1251.3H376.285V1252H372.297V1251.3H368.309V1252H364.319V1251.3H360.331V1252H356.343V1251.3H352.354V1252H348.366V1251.3H344.378V1252H340.39V1251.3H336.401V1252H332.413V1251.3H328.425V1252H324.437V1251.3H320.447V1252H316.459V1251.3H312.471V1252H308.482V1251.3H304.494V1252H300.506V1251.3H296.518V1252H292.529V1251.3H288.541V1252H284.553V1251.3H280.564V1252H276.575V1251.3H272.587V1252H268.599V1251.3H264.61V1252H260.622V1251.3H256.634V1252H252.646V1251.3H248.657V1252H244.669V1251.3H240.681V1252H236.691V1251.3H232.703V1252H228.715V1251.3H224.727V1252H220.738V1251.3H216.75V1252H212.762V1251.3H208.773V1252H204.785V1251.3H200.797V1252H196.809V1251.3H192.819V1252H188.831V1251.3H184.843V1252H180.854V1251.3H176.866V1252H172.878V1251.3H168.89V1252H164.901V1251.3H160.913V1252H156.925V1251.3H152.937V1252H148.947V1251.3H144.959V1252H140.971V1251.3H136.982V1252H132.994V1251.3H131C130.244 1251.3 129.507 1251.23 128.794 1251.08L128.658 1251.77C127.084 1251.46 125.621 1250.84 124.333 1249.98L124.722 1249.4C123.489 1248.57 122.428 1247.51 121.603 1246.28L121.021 1246.67C120.16 1245.38 119.54 1243.92 119.229 1242.34L119.915 1242.21C119.809 1241.67 119.741 1241.12 119.714 1240.56L119.7 1240V1238H119V1234H119.7V1230H119V1226H119.7V1222H119V1218H119.7V1214H119V1210H119.7V1206H119V1202H119.7V1198H119V1194H119.7V1190H119V1186H119.7V1182H119V1178H119.7V1174H119V1170H119.7V1166H119V1162H119.7V1158H119V1154H119.7V1150H119V1146H119.7V1142H119V1138H119.7V1134H119V1130H119.7V1126H119V1122H119.7V1118H119V1114H119.7V1110H119V1106H119.7V1102H119V1098H119.7V1094H119V1090H119.7V1086H119V1082H119.7V1078H119V1074H119.7V1070H119V1066H119.7V1064C119.7 1063.24 119.774 1062.51 119.915 1061.79L119.229 1061.66C119.54 1060.08 120.16 1058.62 121.021 1057.33L121.603 1057.72C122.428 1056.49 123.489 1055.43 124.722 1054.6L124.333 1054.02C125.621 1053.16 127.084 1052.54 128.658 1052.23L128.794 1052.92C129.507 1052.77 130.244 1052.7 131 1052.7H132.994V1052H136.982V1052.7H140.971V1052H144.959V1052.7H148.947V1052H152.936V1052.7H156.925V1052H160.913V1052.7H164.901V1052H168.89V1052.7H172.878V1052H176.866V1052.7H180.854V1052H184.843V1052.7H188.831V1052H192.819V1052.7H196.809V1052H200.797V1052.7H204.785V1052H208.773V1052.7H212.762V1052H216.75V1052.7H220.738V1052H224.727V1052.7H228.715V1052H232.703V1052.7H236.691V1052H240.681V1052.7H244.669V1052H248.657V1052.7H252.646V1052H256.634V1052.7H260.622V1052H264.61V1052.7H268.599V1052H272.587V1052.7H276.575V1052H280.563V1052.7H284.553V1052H288.541V1052.7H292.529V1052H296.518V1052.7H300.506V1052H304.494V1052.7H308.482V1052H312.471V1052.7H316.459V1052H320.447V1052.7H324.437V1052H328.425V1052.7H332.413V1052H336.401V1052.7H340.39V1052H344.378V1052.7H348.366V1052H352.354V1052.7H356.343V1052H360.331V1052.7H364.319V1052H368.309V1052.7H372.297V1052H376.285V1052.7H380.273V1052H384.262V1052.7H388.25V1052H392.238V1052.7H396.227V1052H400.215V1052.7H404.203V1052H408.191V1052.7H412.181V1052H416.169V1052.7H420.157V1052H424.146V1052.7H428.134V1052H432.122V1052.7H436.11V1052H440.099V1052.7H444.087V1052H448.075V1052.7H452.063V1052H456.053V1052.7H460.041V1052H464.029V1052.7H468.018V1052H472.006Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block_2">
              <text
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={147} y={1096.77}>
                  Fat soluble toxins (e.g. heavy metals, hormones,{" "}
                </tspan>
                <tspan x={147} y={1120.77}>
                  pesticides){" "}
                </tspan>
                <tspan x={168} y={1144.77}>
                  Fat cells{" "}
                </tspan>
                <tspan x={168} y={1168.77}>
                  Liver{" "}
                </tspan>
                <tspan x={168} y={1192.77}>
                  Central nervous system{" "}
                </tspan>
                <tspan x={168} y={1216.77}>
                  Bone marrow
                </tspan>
              </text>
            </g>
          </g>
          <g id="Frame 471">
            <path
              d="M875.992 1300V1300.7H878C878.756 1300.7 879.493 1300.77 880.206 1300.92L880.341 1300.23C881.915 1300.54 883.378 1301.16 884.666 1302.02L884.278 1302.6C885.511 1303.43 886.572 1304.49 887.397 1305.72L887.978 1305.33C888.84 1306.62 889.459 1308.08 889.771 1309.66L889.085 1309.79C889.226 1310.51 889.3 1311.24 889.3 1312V1313.94H890V1317.83H889.3V1321.72H890V1325.61H889.3V1329.5H890V1333.39H889.3V1337.28H890V1341.17H889.3V1345.06H890V1348.94H889.3V1352.83H890V1356.72H889.3V1360.61H890V1364.5H889.3V1368.39H890V1372.28H889.3V1376.17H890V1380.06H889.3V1383.94H890V1387.83H889.3V1391.72H890V1395.61H889.3V1399.5H890V1403.39H889.3V1407.28H890V1411.17H889.3V1415.06H890V1418.94H889.3V1422.83H890V1426.72H889.3V1430.61H890V1434.5H889.3V1438.39H890V1442.28H889.3V1446.17H890V1450.06H889.3V1452C889.3 1452.76 889.226 1453.49 889.085 1454.21L889.771 1454.34C889.459 1455.92 888.84 1457.38 887.978 1458.67L887.397 1458.28C886.572 1459.51 885.511 1460.57 884.278 1461.4L884.666 1461.98C883.378 1462.84 881.915 1463.46 880.341 1463.77L880.206 1463.08C879.493 1463.23 878.756 1463.3 878 1463.3H875.992V1464H871.976V1463.3H867.96V1464H863.943V1463.3H859.928V1464H855.911V1463.3H851.896V1464H847.879V1463.3H843.863V1464H839.847V1463.3H835.831V1464H831.814V1463.3H827.799V1464H823.782V1463.3H819.767V1464H815.75V1463.3H811.734V1464H807.718V1463.3H803.702V1464H799.686V1463.3H795.67V1464H791.653V1463.3H787.638V1464H783.621V1463.3H779.605V1464H775.589V1463.3H771.573V1464H767.557V1463.3H763.541V1464H759.524V1463.3H755.509V1464H751.492V1463.3H747.477V1464H743.46V1463.3H739.444V1464H735.428V1463.3H731.412V1464H727.396V1463.3H723.38V1464H719.363V1463.3H715.348V1464H711.331V1463.3H707.315V1464H703.299V1463.3H699.283V1464H695.267V1463.3H691.251V1464H687.234V1463.3H683.219V1464H679.202V1463.3H675.187V1464H671.17V1463.3H667.154V1464H663.138V1463.3H659.122V1464H655.105V1463.3H651.09V1464H647.073V1463.3H643.058V1464H639.041V1463.3H635.025V1464H631.009V1463.3H626.993V1464H622.977V1463.3H618.961V1464H614.944V1463.3H610.928V1464H606.912V1463.3H602.896V1464H598.88V1463.3H594.863V1464H590.848V1463.3H586.831V1464H582.815V1463.3H578.799V1464H574.783V1463.3H570.767V1464H566.751V1463.3H562.734V1464H558.719V1463.3H554.702V1464H550.687V1463.3H546.67V1464H542.653V1463.3H538.638V1464H534.621V1463.3H530.605V1464H526.589V1463.3H522.573V1464H518.557V1463.3H514.541V1464H510.524V1463.3H506.509V1464H502.492V1463.3H498.477V1464H494.46V1463.3H490.444V1464H486.428V1463.3H482.412V1464H478.396V1463.3H474.379V1464H470.363V1463.3H466.347V1464H462.331V1463.3H458.314V1464H454.299V1463.3H450.282V1464H446.267V1463.3H442.25V1464H438.234V1463.3H434.218V1464H430.202V1463.3H426.186V1464H422.17V1463.3H418.153V1464H414.137V1463.3H410.121V1464H406.104V1463.3H402.089V1464H398.072V1463.3H394.057V1464H390.04V1463.3H386.024V1464H382.008V1463.3H377.992V1464H373.976V1463.3H369.96V1464H365.943V1463.3H361.928V1464H357.911V1463.3H353.896V1464H349.879V1463.3H345.863V1464H341.847V1463.3H337.831V1464H333.814V1463.3H329.799V1464H325.782V1463.3H321.766V1464H317.75V1463.3H313.733V1464H309.718V1463.3H305.701V1464H301.686V1463.3H297.669V1464H293.653V1463.3H289.637V1464H285.621V1463.3H281.604V1464H277.589V1463.3H273.572V1464H269.557V1463.3H265.54V1464H261.524V1463.3H257.508V1464H253.492V1463.3H249.476V1464H245.46V1463.3H241.443V1464H237.428V1463.3H233.411V1464H229.396V1463.3H225.379V1464H221.363V1463.3H217.347V1464H213.331V1463.3H209.314V1464H205.299V1463.3H201.282V1464H197.267V1463.3H193.25V1464H189.233V1463.3H185.218V1464H181.201V1463.3H177.186V1464H173.169V1463.3H169.153V1464H165.137V1463.3H161.121V1464H157.104V1463.3H153.089V1464H149.072V1463.3H145.057V1464H141.04V1463.3H137.024V1464H133.008V1463.3H131C130.244 1463.3 129.507 1463.23 128.794 1463.08L128.658 1463.77C127.084 1463.46 125.621 1462.84 124.333 1461.98L124.722 1461.4C123.489 1460.57 122.428 1459.51 121.603 1458.28L121.021 1458.67C120.16 1457.38 119.54 1455.92 119.229 1454.34L119.915 1454.21C119.809 1453.67 119.741 1453.12 119.714 1452.56L119.7 1452V1450.06H119V1446.17H119.7V1442.28H119V1438.39H119.7V1434.5H119V1430.61H119.7V1426.72H119V1422.83H119.7V1418.94H119V1415.06H119.7V1411.17H119V1407.28H119.7V1403.39H119V1399.5H119.7V1395.61H119V1391.72H119.7V1387.83H119V1383.94H119.7V1380.06H119V1376.17H119.7V1372.28H119V1368.39H119.7V1364.5H119V1360.61H119.7V1356.72H119V1352.83H119.7V1348.94H119V1345.06H119.7V1341.17H119V1337.28H119.7V1333.39H119V1329.5H119.7V1325.61H119V1321.72H119.7V1317.83H119V1313.94H119.7V1312C119.7 1311.24 119.774 1310.51 119.915 1309.79L119.229 1309.66C119.54 1308.08 120.16 1306.62 121.021 1305.33L121.603 1305.72C122.428 1304.49 123.489 1303.43 124.722 1302.6L124.333 1302.02C125.621 1301.16 127.084 1300.54 128.658 1300.23L128.794 1300.92C129.507 1300.77 130.244 1300.7 131 1300.7H133.008V1300H137.024V1300.7H141.04V1300H145.057V1300.7H149.072V1300H153.089V1300.7H157.104V1300H161.121V1300.7H165.137V1300H169.153V1300.7H173.169V1300H177.186V1300.7H181.201V1300H185.218V1300.7H189.233V1300H193.25V1300.7H197.266V1300H201.282V1300.7H205.298V1300H209.314V1300.7H213.33V1300H217.347V1300.7H221.362V1300H225.379V1300.7H229.395V1300H233.411V1300.7H237.427V1300H241.443V1300.7H245.459V1300H249.476V1300.7H253.491V1300H257.508V1300.7H261.523V1300H265.54V1300.7H269.556V1300H273.572V1300.7H277.588V1300H281.604V1300.7H285.62V1300H289.637V1300.7H293.652V1300H297.669V1300.7H301.685V1300H305.701V1300.7H309.717V1300H313.733V1300.7H317.749V1300H321.766V1300.7H325.781V1300H329.798V1300.7H333.813V1300H337.83V1300.7H341.846V1300H345.862V1300.7H349.878V1300H353.895V1300.7H357.91V1300H361.927V1300.7H365.942V1300H369.959V1300.7H373.975V1300H377.991V1300.7H382.007V1300H386.023V1300.7H390.039V1300H394.056V1300.7H398.072V1300H402.088V1300.7H406.104V1300H410.12V1300.7H414.137V1300H418.152V1300.7H422.169V1300H426.185V1300.7H430.201V1300H434.217V1300.7H438.233V1300H442.249V1300.7H446.266V1300H450.281V1300.7H454.298V1300H458.313V1300.7H462.33V1300H466.347V1300.7H470.362V1300H474.379V1300.7H478.395V1300H482.411V1300.7H486.427V1300H490.443V1300.7H494.459V1300H498.476V1300.7H502.491V1300H506.508V1300.7H510.523V1300H514.54V1300.7H518.556V1300H522.572V1300.7H526.588V1300H530.604V1300.7H534.621V1300H538.637V1300.7H542.653V1300H546.669V1300.7H550.686V1300H554.701V1300.7H558.718V1300H562.733V1300.7H566.75V1300H570.766V1300.7H574.782V1300H578.798V1300.7H582.814V1300H586.83V1300.7H590.847V1300H594.863V1300.7H598.879V1300H602.896V1300.7H606.911V1300H610.928V1300.7H614.943V1300H618.96V1300.7H622.976V1300H626.992V1300.7H631.008V1300H635.024V1300.7H639.04V1300H643.057V1300.7H647.072V1300H651.089V1300.7H655.104V1300H659.121V1300.7H663.137V1300H667.153V1300.7H671.169V1300H675.186V1300.7H679.201V1300H683.218V1300.7H687.234V1300H691.25V1300.7H695.267V1300H699.282V1300.7H703.299V1300H707.314V1300.7H711.331V1300H715.347V1300.7H719.363V1300H723.379V1300.7H727.396V1300H731.411V1300.7H735.428V1300H739.443V1300.7H743.46V1300H747.476V1300.7H751.492V1300H755.508V1300.7H759.524V1300H763.54V1300.7H767.557V1300H771.572V1300.7H775.589V1300H779.604V1300.7H783.621V1300H787.637V1300.7H791.653V1300H795.669V1300.7H799.686V1300H803.701V1300.7H807.718V1300H811.733V1300.7H815.75V1300H819.767V1300.7H823.782V1300H827.799V1300.7H831.814V1300H835.831V1300.7H839.847V1300H843.863V1300.7H847.879V1300H851.896V1300.7H855.911V1300H859.928V1300.7H863.943V1300H867.96V1300.7H871.976V1300H875.992Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block_3">
              <text
                id="H2 Header"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={147} y={1348.15}>
                  Signs of toxicity
                </tspan>
              </text>
              <g id="Frame 472_2">
                <text
                  id="Acne/skin rash Allergies Arthritis/joint pain"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={168} y={1380.77}>
                    Acne/skin rash{" "}
                  </tspan>
                  <tspan x={168} y={1404.77}>
                    Allergies{" "}
                  </tspan>
                  <tspan x={168} y={1428.77}>
                    Arthritis/joint pain
                  </tspan>
                </text>
                <text
                  id="Chronic fatigue Constipation IBS"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={458} y={1380.77}>
                    Chronic fatigue{" "}
                  </tspan>
                  <tspan x={458} y={1404.77}>
                    Constipation{" "}
                  </tspan>
                  <tspan x={458} y={1428.77}>
                    IBS
                  </tspan>
                </text>
                <text
                  id="Excess weight Hormone imbalance"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={731} y={1380.77}>
                    Excess weight{" "}
                  </tspan>
                  <tspan x={731} y={1404.77}>
                    Hormone imbalance
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="Frame 470">
            <path
              d="M865.006 1052V1052.7H867C867.756 1052.7 868.493 1052.77 869.206 1052.92L869.341 1052.23C870.915 1052.54 872.378 1053.16 873.666 1054.02L873.278 1054.6C874.511 1055.43 875.572 1056.49 876.397 1057.72L876.978 1057.33C877.84 1058.62 878.459 1060.08 878.771 1061.66L878.085 1061.79C878.226 1062.51 878.3 1063.24 878.3 1064V1066H879V1070H878.3V1074H879V1078H878.3V1082H879V1086H878.3V1090H879V1094H878.3V1098H879V1102H878.3V1106H879V1110H878.3V1114H879V1118H878.3V1122H879V1126H878.3V1130H879V1134H878.3V1138H879V1142H878.3V1146H879V1150H878.3V1154H879V1158H878.3V1162H879V1166H878.3V1170H879V1174H878.3V1178H879V1182H878.3V1186H879V1190H878.3V1194H879V1198H878.3V1202H879V1206H878.3V1210H879V1214H878.3V1218H879V1222H878.3V1226H879V1230H878.3V1234H879V1238H878.3V1240C878.3 1240.76 878.226 1241.49 878.085 1242.21L878.771 1242.34C878.459 1243.92 877.84 1245.38 876.978 1246.67L876.397 1246.28C875.572 1247.51 874.511 1248.57 873.278 1249.4L873.666 1249.98C872.378 1250.84 870.915 1251.46 869.341 1251.77L869.206 1251.08C868.493 1251.23 867.756 1251.3 867 1251.3H865.006V1252H861.018V1251.3H857.029V1252H853.041V1251.3H849.053V1252H845.064V1251.3H841.075V1252H837.087V1251.3H833.099V1252H829.11V1251.3H825.122V1252H821.134V1251.3H817.146V1252H813.157V1251.3H809.169V1252H805.181V1251.3H801.191V1252H797.203V1251.3H793.215V1252H789.227V1251.3H785.238V1252H781.25V1251.3H777.262V1252H773.273V1251.3H769.285V1252H765.297V1251.3H761.309V1252H757.319V1251.3H753.331V1252H749.343V1251.3H745.354V1252H741.366V1251.3H737.378V1252H733.39V1251.3H729.401V1252H725.413V1251.3H721.425V1252H717.437V1251.3H713.447V1252H709.459V1251.3H705.471V1252H701.482V1251.3H697.494V1252H693.506V1251.3H689.518V1252H685.529V1251.3H681.541V1252H677.553V1251.3H673.564V1252H669.575V1251.3H665.587V1252H661.599V1251.3H657.61V1252H653.622V1251.3H649.634V1252H645.646V1251.3H641.657V1252H637.669V1251.3H633.681V1252H629.691V1251.3H625.703V1252H621.715V1251.3H617.727V1252H613.738V1251.3H609.75V1252H605.762V1251.3H601.773V1252H597.785V1251.3H593.797V1252H589.809V1251.3H585.819V1252H581.831V1251.3H577.843V1252H573.854V1251.3H569.866V1252H565.878V1251.3H561.89V1252H557.901V1251.3H553.913V1252H549.925V1251.3H545.937V1252H541.947V1251.3H537.959V1252H533.971V1251.3H529.982V1252H525.994V1251.3H524C523.244 1251.3 522.507 1251.23 521.794 1251.08L521.658 1251.77C520.084 1251.46 518.621 1250.84 517.333 1249.98L517.722 1249.4C516.489 1248.57 515.428 1247.51 514.603 1246.28L514.021 1246.67C513.16 1245.38 512.54 1243.92 512.229 1242.34L512.915 1242.21C512.809 1241.67 512.741 1241.12 512.714 1240.56L512.7 1240V1238H512V1234H512.7V1230H512V1226H512.7V1222H512V1218H512.7V1214H512V1210H512.7V1206H512V1202H512.7V1198H512V1194H512.7V1190H512V1186H512.7V1182H512V1178H512.7V1174H512V1170H512.7V1166H512V1162H512.7V1158H512V1154H512.7V1150H512V1146H512.7V1142H512V1138H512.7V1134H512V1130H512.7V1126H512V1122H512.7V1118H512V1114H512.7V1110H512V1106H512.7V1102H512V1098H512.7V1094H512V1090H512.7V1086H512V1082H512.7V1078H512V1074H512.7V1070H512V1066H512.7V1064C512.7 1063.24 512.774 1062.51 512.915 1061.79L512.229 1061.66C512.54 1060.08 513.16 1058.62 514.021 1057.33L514.603 1057.72C515.428 1056.49 516.489 1055.43 517.722 1054.6L517.333 1054.02C518.621 1053.16 520.084 1052.54 521.658 1052.23L521.794 1052.92C522.507 1052.77 523.244 1052.7 524 1052.7H525.994V1052H529.982V1052.7H533.971V1052H537.959V1052.7H541.947V1052H545.936V1052.7H549.925V1052H553.913V1052.7H557.901V1052H561.89V1052.7H565.878V1052H569.866V1052.7H573.854V1052H577.843V1052.7H581.831V1052H585.819V1052.7H589.809V1052H593.797V1052.7H597.785V1052H601.773V1052.7H605.762V1052H609.75V1052.7H613.738V1052H617.727V1052.7H621.715V1052H625.703V1052.7H629.691V1052H633.681V1052.7H637.669V1052H641.657V1052.7H645.646V1052H649.634V1052.7H653.622V1052H657.61V1052.7H661.599V1052H665.587V1052.7H669.575V1052H673.563V1052.7H677.553V1052H681.541V1052.7H685.529V1052H689.518V1052.7H693.506V1052H697.494V1052.7H701.482V1052H705.471V1052.7H709.459V1052H713.447V1052.7H717.437V1052H721.425V1052.7H725.413V1052H729.401V1052.7H733.39V1052H737.378V1052.7H741.366V1052H745.354V1052.7H749.343V1052H753.331V1052.7H757.319V1052H761.309V1052.7H765.297V1052H769.285V1052.7H773.273V1052H777.262V1052.7H781.25V1052H785.238V1052.7H789.227V1052H793.215V1052.7H797.203V1052H801.191V1052.7H805.181V1052H809.169V1052.7H813.157V1052H817.146V1052.7H821.134V1052H825.122V1052.7H829.11V1052H833.099V1052.7H837.087V1052H841.075V1052.7H845.063V1052H849.053V1052.7H853.041V1052H857.029V1052.7H861.018V1052H865.006Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block_4">
              <text
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={540} y={1096.77}>
                  Water soluble toxins (e.g. nicotine and other{" "}
                </tspan>
                <tspan x={540} y={1120.77}>
                  chemicals{" "}
                </tspan>
                <tspan x={561} y={1144.77}>
                  Blood{" "}
                </tspan>
                <tspan x={561} y={1168.77}>
                  Muscles{" "}
                </tspan>
                <tspan x={561} y={1192.77}>
                  Joints{" "}
                </tspan>
                <tspan x={561} y={1216.77}>
                  Tissues
                </tspan>
              </text>
            </g>
          </g>
          <g id="Frame 468_2">
            <rect
              x={32.7}
              y={497.2}
              width={154.6}
              height={234.6}
              stroke="#282828"
              strokeWidth={1.4}
            />
            <g id="Rich Text Block_5">
              <text
                id="H2 Header_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={48} y={544.647}>
                  Toxins
                </tspan>
              </text>
              <text
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={48} y={577.267}>
                  Enter through:{" "}
                </tspan>
                <tspan x={48} y={601.267}>
                  {" "}
                </tspan>
                <tspan x={69} y={625.267}>
                  Lung{" "}
                </tspan>
                <tspan x={69} y={649.267}>
                  Skin{" "}
                </tspan>
                <tspan x={69} y={673.267}>
                  Gut/Intestine{" "}
                </tspan>
                <tspan x={69} y={697.267}>
                  (small)
                </tspan>
              </text>
            </g>
          </g>
          <g id="Frame 469">
            <rect
              x={810.7}
              y={497.2}
              width={182.6}
              height={234.6}
              stroke="#282828"
              strokeWidth={1.4}
            />
            <g id="Rich Text Block_6">
              <text
                id="H2 Header_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={838} y={544.647}>
                  Toxins
                </tspan>
              </text>
              <text
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={838} y={577.267}>
                  Exit through:{" "}
                </tspan>
                <tspan x={838} y={601.267}>
                  {" "}
                </tspan>
                <tspan x={859} y={625.267}>
                  Lung{" "}
                </tspan>
                <tspan x={859} y={649.267}>
                  Skin{" "}
                </tspan>
                <tspan x={859} y={673.267}>
                  Colon{" "}
                </tspan>
                <tspan x={859} y={697.267}>
                  Kidneys
                </tspan>
              </text>
            </g>
          </g>
          <path
            id="Vector 423_2"
            d="M188 618L187.326 617.811L187.278 617.983L187.318 618.156L188 618ZM247.5 406V405.3H246.969L246.826 405.811L247.5 406ZM256 406L249 401.959V410.041L256 406ZM247.5 461V460.3H247.017L246.845 460.752L247.5 461ZM256 461L249 456.959V465.041L256 461ZM247.5 511.5V510.8H247.089L246.889 511.159L247.5 511.5ZM256 511.5L249 507.459V515.541L256 511.5ZM247.5 562V561.3H247.222L247.02 561.49L247.5 562ZM256 562L249 557.959V566.041L256 562ZM256 618L249 613.959V622.041L256 618ZM247.5 668L247.05 668.536L247.245 668.7H247.5V668ZM256 668L249 663.959V672.041L256 668ZM247.5 720L246.895 720.353L247.098 720.7H247.5V720ZM256 720L249 715.959V724.041L256 720ZM247.5 773.5L246.846 773.75L247.018 774.2H247.5V773.5ZM256 773.5L249 769.459V777.541L256 773.5ZM247.5 823.5L246.828 823.695L246.974 824.2H247.5V823.5ZM256 823.5L249 819.459V827.541L256 823.5ZM247.5 877.5L246.818 877.656L246.942 878.2H247.5V877.5ZM256 877.5L249 873.459V881.541L256 877.5ZM188 618L188.674 618.189L248.174 406.189L247.5 406L246.826 405.811L187.326 617.811L188 618ZM247.5 406V406.7H249.7V406V405.3H247.5V406ZM188 618L188.655 618.248L248.155 461.248L247.5 461L246.845 460.752L187.345 617.752L188 618ZM247.5 461V461.7H249.7V461V460.3H247.5V461ZM188 618L188.611 618.341L248.111 511.841L247.5 511.5L246.889 511.159L187.389 617.659L188 618ZM247.5 511.5V512.2H249.7V511.5V510.8H247.5V511.5ZM188 618L188.48 618.51L247.98 562.51L247.5 562L247.02 561.49L187.52 617.49L188 618ZM247.5 562V562.7H249.7V562V561.3H247.5V562ZM188 618V618.7H249.7V618V617.3H188V618ZM188 618L187.55 618.536L247.05 668.536L247.5 668L247.95 667.464L188.45 617.464L188 618ZM247.5 668V668.7H249.7V668V667.3H247.5V668ZM188 618L187.395 618.353L246.895 720.353L247.5 720L248.105 719.647L188.605 617.647L188 618ZM247.5 720V720.7H249.7V720V719.3H247.5V720ZM188 618L187.346 618.25L246.846 773.75L247.5 773.5L248.154 773.25L188.654 617.75L188 618ZM247.5 773.5V774.2H249.7V773.5V772.8H247.5V773.5ZM188 618L187.328 618.195L246.828 823.695L247.5 823.5L248.172 823.305L188.672 617.805L188 618ZM247.5 823.5V824.2H249.7V823.5V822.8H247.5V823.5ZM188 618L187.318 618.156L246.818 877.656L247.5 877.5L248.182 877.344L188.682 617.844L188 618ZM247.5 877.5V878.2H249.7V877.5V876.8H247.5V877.5Z"
            fill="#282828"
          />
          <g id="lines_4">
            <path
              id="Vector_4"
              d="M295.658 1252.7L295.658 1252L294.258 1252L294.258 1252.7L294.958 1252.7L295.658 1252.7ZM294.958 1294L299 1287L290.917 1287L294.958 1294ZM294.958 1252.7L294.258 1252.7L294.258 1287.7L294.958 1287.7L295.658 1287.7L295.658 1252.7L294.958 1252.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_5">
            <path
              id="Vector_5"
              d="M693.658 1252.7L693.658 1252L692.258 1252L692.258 1252.7L692.958 1252.7L693.658 1252.7ZM692.958 1294L697 1287L688.917 1287L692.958 1294ZM692.958 1252.7L692.258 1252.7L692.258 1287.7L692.958 1287.7L693.658 1287.7L693.658 1252.7L692.958 1252.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Report titles_5">
            <rect width={214} height={28} transform="translate(387 1004)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={387.16} y={1024.12}>
                Excess toxins get stored in
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </>
  );
};

const SvgMethylationDetoxificationOverviewDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1344}
    viewBox="0 176 1024 1344"
    fill="none"
    {...props}
  >
    <MethylationDetoxificationOverviewDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18291_211478">
        <rect width={1024} height={1520} fill="white" />
      </clipPath>
      <clipPath id="clip1_18291_211478">
        <rect width={1024} height={1344} fill="white" transform="translate(0 176)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMethylationDetoxificationOverviewDiagram;
